export type LangTextItem = {
    product_name: string;
    product_name1: string;
    tab_product: string;
    tab_support: string;
    tab_specs: string;
    btn_buy: string;
};

export type LangTextType = {
    [key: string]: LangTextItem;
};

export const LangText: LangTextType = {
    us: {
        product_name: 'EcoFlow STREAM Microinverter',
        product_name1: 'EcoFlow STREAM Ultra',
        tab_product: 'Overview',
        tab_support: 'Support',
        tab_specs: 'Specs',
        btn_buy: 'Buy Now',
    },
};
